/**
 * Private modules
 */
const {
  basePercent,
  createQueryComponent,
  creditAmount,
  customerId,
  isDemo,
  limitMode,
  objectId,
  offsetPercent,
  systemGameId,
} = require('../.private').components;

module.exports = {
  getCustomerRunnerPropertyBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  updateCustomerRunnerPropertyBasePercentById: {
    properties: {
      body: {
        properties: {
          basePercent,
        },
        required: ['basePercent'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          objectId,
        },
        required: [
          'customerId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  updateCustomerRunnerPropertyById: {
    properties: {
      body: {
        properties: {
          creditAmount,
          isDemo,
        },
        required: [
          'creditAmount',
          'isDemo',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          objectId,
        },
        required: [
          'customerId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  updateCustomerRunnerPropertyLimitModeById: {
    properties: {
      body: {
        properties: {
          limitMode,
        },
        required: ['limitMode'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          objectId,
        },
        required: [
          'customerId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  updateCustomerRunnerPropertyOffsetPercentById: {
    properties: {
      body: {
        properties: {
          offsetPercent,
        },
        required: ['offsetPercent'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          objectId,
        },
        required: [
          'customerId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
